(function(){
  // In-page links (subnav, table of contents, hero buttons, "see dosage" etc.):
  // scroll to the section but never write a #hash into the address bar.
  function headerOffset(){
    var h=document.getElementById('header-component');
    return h?h.getBoundingClientRect().height:0;
  }
  function goTo(target){
    var top=target.getBoundingClientRect().top+window.scrollY-headerOffset()-12;
    window.scrollTo({top:Math.max(0,top),behavior:'smooth'});
    if(target.tabIndex<0) target.setAttribute('tabindex','-1');
    try{target.focus({preventScroll:true});}catch(e){}
  }
  document.addEventListener('click',function(e){
    if(e.defaultPrevented||e.button!==0||e.metaKey||e.ctrlKey||e.shiftKey||e.altKey) return;
    var a=e.target&&e.target.closest?e.target.closest('a[href]'):null;
    if(!a) return;
    var url;
    try{url=new URL(a.getAttribute('href'),location.href);}catch(err){return;}
    if(url.origin!==location.origin||url.pathname!==location.pathname||url.search!==location.search) return;
    if(!url.hash||url.hash==='#') return;
    var target=document.getElementById(decodeURIComponent(url.hash.slice(1)));
    if(!target) return;
    e.preventDefault();
    goTo(target);
  },true);
  // A shared link that already carries a #hash still lands on its section,
  // but the hash is removed from the address bar afterwards.
  if(location.hash&&history.replaceState){
    try{history.replaceState(null,'',location.pathname+location.search);}catch(e){}
  }

  var bar=document.getElementById('progress');
  function prog(){
    if(!bar) return;
    var h=document.documentElement, max=h.scrollHeight-h.clientHeight;
    bar.style.width=(max>0?(h.scrollTop/max)*100:0)+'%';
  }
  window.addEventListener('scroll',prog,{passive:true});
  window.addEventListener('resize',prog); prog();

  var ids=['origin','grayanotoxin','harvest','variance','benefits','dosage','legal','varieties','faq'];
  var links=[].slice.call(document.querySelectorAll('.subnav a[href^="#"], .toc a[href^="#"]'));
  var secs=ids.map(function(i){return document.getElementById(i);}).filter(Boolean);
  function spy(){
    var pos=window.scrollY+150, cur=null;
    secs.forEach(function(s){ if(s.getBoundingClientRect().top+window.scrollY<=pos) cur=s.id; });
    links.forEach(function(a){ a.classList.toggle('on', a.getAttribute('href')==='#'+cur); });
  }
  window.addEventListener('scroll',spy,{passive:true}); spy();

  // sticky buy bar appears once past the hero
  var sticky=document.getElementById('stickybuy'), dismissed=false;
  try{dismissed=sessionStorage.getItem('bmh-sticky')==='off';}catch(e){}
  if(sticky){
    if(dismissed) sticky.classList.add('off');
    var foot=document.querySelector('.cta');
    window.addEventListener('scroll',function(){
      var nearEnd=foot&&foot.getBoundingClientRect().top<window.innerHeight;
      sticky.classList.toggle('on', window.scrollY>700&&!nearEnd);
    },{passive:true});
    var sx=document.getElementById('stickyx');
    if(sx) sx.addEventListener('click',function(){
      sticky.classList.add('off');
      try{sessionStorage.setItem('bmh-sticky','off');}catch(e){}
    });
  }

  // lead form: light validation
  var lf=document.getElementById('first-jar-form');
  if(lf){
    lf.addEventListener('submit',function(e){
      var em=document.getElementById('lead-email');
      if(!em||!em.value||em.value.indexOf('@')<1){e.preventDefault();if(em){em.focus();em.setAttribute('aria-invalid','true');}}
    });
  }

  // harvest finder
  var pick={exp:null,size:null};
  var data=window.__mhpFinder||{};
  var opts=[].slice.call(document.querySelectorAll('.opt'));
  opts.forEach(function(b){
    b.addEventListener('click',function(){
      var q=b.dataset.q;
      opts.filter(function(x){return x.dataset.q===q;}).forEach(function(x){x.setAttribute('aria-pressed','false');});
      b.setAttribute('aria-pressed','true');
      pick[q]=b.dataset.v;
      if(pick.exp&&pick.size){
        var r=data[pick.exp+'|'+pick.size];
        if(!r) return;
        document.getElementById('rName').textContent=r[0];
        document.getElementById('rWhy').textContent=r[1];
        document.getElementById('rMeta').textContent=r[2];
        document.getElementById('rLink').href=r[3];
        document.getElementById('result').classList.add('on');
        var sn=document.getElementById('stickyName'), ss=document.getElementById('stickySub'), sl=document.getElementById('stickyLink');
        if(sn){ sn.textContent=r[0]+' · '+r[2].split(' · ')[0]; ss.textContent='Your match from the harvest finder'; sl.href=r[3]; }
      }
    });
  });
})();
